export default __webpack_public_path__ + "static/media/taxi.62e79a71.svg";